import types from '../actions/types';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
// import {ignoreElements, tap} from "rxjs/operators/index";
import { selectObject } from "../actions";

export const newTextEpic = (action$, store$) =>
  action$.pipe(
    ofType(types.ADD_NEW_TEXT_OBJECT),
    map(action => {
      const id = action.payload.uuid;
      const state = store$.getState();
      const surface = state.objects.present.currentSurface.surface.id;
      const object = state.objects.present.objects[surface][id];

      return selectObject(object);
    })
  );

export const copyEpic = (action$, store$) =>
  action$.pipe(
    ofType(types.COPY_OBJECT),
    map(action => {
      const id = action.payload.uuid;
      const state = store$.getState();
      const surface = state.objects.present.currentSurface.surface.id;
      const object = state.objects.present.objects[surface][id];

      return selectObject(object);
    })
  );


// WEBPACK FOOTER //
// ./src/epics/objectsEpic.js